module.exports = __webpack_public_path__ + "4b2b5e2e93fc55996873341db282863a.jpg";